const formatJson = (value?: string | null, space = 2): string | null => {
  try {
    return JSON.stringify(JSON.parse(value as string), null, space);
  } catch {
    return null;
  }
};

export default formatJson;
